import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

export const getCareEventsBillingQueryKey = () => ["getCareEventsBilling"] as const;

export const useGetCareEventsBilling = () => {
  const client = useApiClient();

  return useQuery(getCareEventsBillingQueryKey(), () => client.getCareEventsBilling());
};
